/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * ADLレベル
 */
export type RequestSummaryADLLevelEnum =
  (typeof RequestSummaryADLLevelEnum)[keyof typeof RequestSummaryADLLevelEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RequestSummaryADLLevelEnum = {
  FIRST: 'FIRST',
  SECOND: 'SECOND',
  THIRD: 'THIRD',
  FOURTH: 'FOURTH',
  FIFTH: 'FIFTH',
  UNKNOWN: 'UNKNOWN',
} as const;
